export const featuresTranslations = {
  nl: {
    sectionTitle: "Ons Aanbod",
    title: "Alles Wat U Nodig Heeft Voor Een Smaakvolle Ervaring",
    subtitle: "Van dagelijkse maaltijden tot verse producten en catering voor uw speciale evenementen, Ams Food Market is uw one-stop-shop voor authentieke smaken.",
    feature1Title: "Verse Groenten & Producten",
    feature1Desc: "Vind een breed scala aan verse groenten en essentiële ingrediënten voor uw Indiase, Sri Lankaanse en Surinaamse kookbehoeften.",
    feature1Link: "Bezoek Winkel",
    feature2Title: "Zaterdag Marktstand",
    feature2Desc: "Bezoek ons elke zaterdag op de markt in Lelystad voor uw favoriete maaltijden en producten. Vind ons naast het loempiakraampje!",
    feature2Link: "Markt Details",
    feature3Title: "Afhalen & Bezorgen",
    feature3Desc: "Bestel gemakkelijk uw maaltijden en kies voor afhalen of bezorgen in Lelystad.",
    feature3Link: "Bestel Nu",
    feature4Title: "Catering Diensten",
    feature4Desc: "Een evenement gepland? Wij bieden catering voor maximaal 100 personen met heerlijke, op maat gemaakte menu's.",
    feature4Link: "Catering Info",
  },
  en: {
    sectionTitle: "Our Offerings",
    title: "Everything You Need For A Flavorful Experience",
    subtitle: "From daily meals to fresh products and catering for your special events, Ams Food Market is your one-stop-shop for authentic tastes.",
    feature1Title: "Fresh Vegetables & Products",
    feature1Desc: "Find a wide range of fresh vegetables and essential ingredients for your Indian, Sri Lankan, and Surinamese cooking needs.",
    feature1Link: "Visit Store",
    feature2Title: "Saturday Market Stall",
    feature2Desc: "Visit us every Saturday at the market in Lelystad for your favorite meals and products. Find us next to the spring roll stall!",
    feature2Link: "Market Details",
    feature3Title: "Takeaway & Delivery",
    feature3Desc: "Easily order your meals and choose takeaway or delivery in Lelystad.",
    feature3Link: "Order Now",
    feature4Title: "Catering Services",
    feature4Desc: "Planning an event? We offer catering for up to 100 people with delicious, custom-made menus.",
    feature4Link: "Catering Info",
  },
};